export const ICON_ONLY = 'icon-only';
export const LABEL_ONLY = 'label-only';
export const ICON_LABEL = 'icon-label';
